// extracted by mini-css-extract-plugin
export var editInput = "_gq-0";
export var editInputCompact = "_gq-2";
export var editInputLarge = "_gq-1";
export var editInputSmall = "_gq-3";